export { HandleConsent } from './HandleConsent';
